import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Database } from "@/integrations/supabase/types";

export type HeroVariant = Database["public"]["Tables"]["hero_variants"]["Row"];

export const fallbackHeroVariant: HeroVariant = {
  id: "fallback-msp",
  page_slug: "home",
  name: "MSP",
  headline: "Managed IT Services",
  headline_secondary: "That Scales Your Business",
  highlighted_phrase: "Your Business",
  typewriter_prefix: "IT",
  typewriter_words: "Solutions.,AI Solutions.,Security.,Services.,Support.,Management.,Cloud.",
  subheadline: "Flat-rate IT, security, and cloud management for growing businesses. Starting at $125 per user/month.",
  show_branding: false,
  cta_primary_label: "Get a Free IT & Security Assessment",
  cta_primary_link: "",
  cta_secondary_label: "View Pricing Plans",
  cta_secondary_link: "#pricing",
  cta_tertiary_label: "",
  cta_tertiary_link: "",
  is_active: true,
  updated_by: null,
  created_at: "",
  updated_at: "",
};

export function useActiveHeroVariant(pageSlug = "home") {
  return useQuery({
    queryKey: ["hero-variants", pageSlug, "active"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("hero_variants")
        .select("*")
        .eq("page_slug", pageSlug)
        .eq("is_active", true)
        .maybeSingle();

      if (error) throw error;
      return data ?? fallbackHeroVariant;
    },
    staleTime: 5 * 60 * 1000,
  });
}